<template>
    <div
        class="el-form-item__error"
        v-if="
            form.errors.has(field) ||
            (form.veeErrors && form.veeErrors.has(field))
        "
    >
        <span v-if="form.errors.has(field)">{{ message }}</span>
        <span v-else-if="form.veeErrors && form.veeErrors.has(field)">{{
            message
        }}</span>
    </div>
</template>

<script>
export default {
    props: {
        form: {
            required: true,
            type: Object,
        },
        field: {
            required: true,
        },
        forceShow: {
            required: false,
            default: true,
            type: Boolean,
        },
        customMessage: {
            type: String,
        },
        scope: {
            type: String,
            default: null,
        },
    },
    computed: {
        message() {
            if (this.customMessage) {
                return this.customMessage;
            }
            return this.form.errors.get(this.field);
        },
    },
};
</script>

<style lang="scss" scoped>
.force-show {
    display: block !important;
}
</style>
